import { LiturgyType } from "./modules/admin/services/liturgy-type.service";
import { LectionaryItemName } from "./modules/admin/services/lectionary-item-name.service";
import { LectionaryItemType, LectionaryItemTypeSubType } from "./modules/admin/services/lectionary-item-type.service";
import { LectionarySource } from "./modules/admin/services/lectionary-source.service";
import { LectionaryTrack } from "./modules/admin/components/lectionary-track/lectionary-track.component";
import { Service } from "./modules/admin/services/service.service";


export class VestmentColor {
  Id: string;
  ReligionBranch: any;
  ColorCode: string;
  Localized: Localized[];
}

export class Localized {
  Name: string;
  Description: string;
  AbbreviatedName: string;
  AlternateName: string;
  LanguageCode: string;
  Code: string;
  Html: string;
  Hyperlinks: any[];
}

export class ReligionBranchType {
  Id: string;
  Name: string;
  Description: string;
}

export class Proper {
  Id: string;
  ProperNumber: number;
  Weekday: number;
  LiturgyType: LiturgyType;
  IsProofed: boolean;
}


export class Season {
  Id: number;
  ReligionBranch: any;
  DisplayOrder: number;

  Localized: Localized[];
}

export class LectionaryItemMap {
  Id: string;
  DisplayOrder: number; 
  LectionaryItemName: LectionaryItemName;
  LectionaryItemType: LectionaryItemType;
  LectionaryItemTypeSubType: LectionaryItemTypeSubType;
  LectionarySource: LectionarySource;
  LectionarySourcePageNumber: string;
  LectionaryTrack: LectionaryTrack;
  LectionaryYear: any;
  LiturgyType: LiturgyType; 

  Service: Service; 
  Proper: Proper; 
}

export class UserAccount {
  Id: string;
  Email: string;
  UserName: string;
  FirstName: string;
  LastName: string;
  IsActive: boolean;
  Role: string;
  RoleId: any;
  RegistrationStatus: string;
  RegistrationStatusId: any;
}

export class Hyperlink {
  Id: number;
  Url: string;
  AnchorText: string;
  Description: string;
}

export class LiturgyTypeLectionaryItemTypeDisplayOrder {
  Id: number;
  LiturgyType: LiturgyType;
  LectionaryItemType: LectionaryItemType; 
  LectionaryItemTypeSubType: any;
  DisplayOrder: number;
}
